var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#FFF3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FEE7E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 60L48 35L62 60H34ZM48.9068 55.6743C49.1508 55.4221 49.2727 55.1096 49.2727 54.7368C49.2727 54.364 49.1508 54.0515 48.9068 53.7993C48.6629 53.5471 48.3606 53.4211 48 53.4211C47.6394 53.4211 47.3371 53.5471 47.0932 53.7993C46.8492 54.0515 46.7273 54.364 46.7273 54.7368C46.7273 55.1096 46.8492 55.4221 47.0932 55.6743C47.3371 55.9265 47.6394 56.0526 48 56.0526C48.3606 56.0526 48.6629 55.9265 48.9068 55.6743ZM46.7273 52.1053H49.2727V45.5263H46.7273V52.1053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeWarning);
export default __webpack_public_path__ + "static/media/merge_warning.d93b2b5bf637bab9139176a8fba62a0d.svg";
export { ForwardRef as ReactComponent };